import { animated as _animated } from "react-spring";

// react-spring@9.7.x predates React 19. React 19 removed implicit children and
// HTML event props from animated element types. This wrapper restores them until
// react-spring is upgraded to v10.
type AnyAnimated = React.ComponentType<
  React.PropsWithChildren<Record<string, any>>
>;

type FixedAnimated = {
  [K in keyof typeof _animated]: AnyAnimated;
} & {
  <T extends React.ElementType>(component: T): AnyAnimated;
};

export const animated = _animated as unknown as FixedAnimated;
